import { ref } from 'vue';
import { externalListsClient } from '~/services';
import { createGlobalState } from '@vueuse/core';

export const useExternalListsGroupsCount = createGlobalState(() => {
    const teamId = Spark.state.currentTeam.id;

    // [externalListId]: groupsCount
    // undefined = loading
    // null = not found
    const groupCounts = ref<Record<number, number | null>>({});

    const fetching = ref(false);

    const fetchExternalListsGroupsCount = async (externalListIds: number[]) => {
        // remove existing ids to avoid computing them again
        externalListIds = externalListIds.filter((externalListId) => groupCounts.value[externalListId] === undefined);

        if (externalListIds.length === 0) {
            return;
        }

        if (fetching.value) {
            // when its currently making a request call wait a bit before retrieving again
            setTimeout(() => {
                fetchExternalListsGroupsCount(externalListIds);
            }, 500);
            return;
        }

        try {
            fetching.value = true;

            const response = await externalListsClient.getExternalListsGroupCount(
                { teamId },
                {
                    external_contact_list_ids: externalListIds,
                }
            );

            externalListIds.forEach((externalListId) => {
                groupCounts.value[externalListId] = response.data.counts[externalListId] ?? null;
            });
        } finally {
            fetching.value = false;
        }
    };

    return {
        fetchExternalListsGroupsCount,
        groupCounts,
    };
});
